export var TypeaheadOptions = (function () {
    function TypeaheadOptions(options) {
        Object.assign(this, options);
    }
    return TypeaheadOptions;
}());
//# sourceMappingURL=typeahead-options.class.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/typeahead/typeahead-options.class.js
// module id = 821
// module chunks = 4